import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  background-color: #00468B;
  min-height: 60px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  img {
    width: 40px;
    height: 40px;
  }

  @media (max-width: 768px) {
    img {
      width: 32px;
      height: 32px;
    }
  }
`;

export const Title = styled.h1`
  color: var(--white);
  font-size: 1.25rem;
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.10rem;
  }
`;

export const MenuButton = styled.button`
  position: relative;
  background: none;
  border: none;
  color: var(--white);
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 2px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const MenuDropdown = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 180px;
  background-color: var(--white);
  border-radius: 2px;
  overflow: hidden;
  z-index: 1000;
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.875rem 1rem;
  background: none;
  border: none;
  color: var(--text-gray);
  font-size: 0.9375rem;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--light-gray);
  }

  svg {
    font-size: 1.25rem;
    color: var(--blue);
  }
`;
